module.exports = "/_next/static/images/5f83834568d32240ad7d60425658d610-phone-desktop.png";